export const isLocal = () => {
  const isTest = import.meta.env.VITE_TEST === 'true';
  if (isTest) return false;
  return location.host.includes('localhost');
};
